import type { MediaImageInterface } from '@hypercodestudio/basler-components';

import { generateImageObject } from '~/utils/generateImageObject';
import { normalizeContentfulAssetUrl } from '~/utils/isSvgImage';

export const SPECIFICATION_LOGO_ROW_HEIGHT = '32' as const;

const LOGO_ROW_IMAGE_WIDTHS = [64, 128, 200] as const;

function stripContentfulTransformParams(url: string): string {
  return normalizeContentfulAssetUrl(url).split('?')[0]?.split('#')[0] ?? url;
}

/**
 * Builds a responsive `MediaImageInterface` for PDP specification logos.
 */
export function buildSpecificationLogoImage(
  imageUrl: string,
  alt: string
): MediaImageInterface | undefined {
  const media = generateImageObject(
    { url: stripContentfulTransformParams(imageUrl), altTag: alt },
    {
      widths: [...LOGO_ROW_IMAGE_WIDTHS],
      sizes: '200px',
      fit: 'pad',
      quality: 60,
      height: Number(SPECIFICATION_LOGO_ROW_HEIGHT)
    }
  );

  if (!media || media.type !== 'image') {
    return undefined;
  }

  return media.content as MediaImageInterface;
}
